import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { websiteApi } from "../../../api/websiteApi";
import { useNotifications } from "../../../context/NotificationContext";
import "./RequestStatus.css";

const STATUS_LABELS = {
  pending: "Pending review",
  approved: "Approved",
  rejected: "Rejected",
  in_progress: "In progress",
  ready_for_review: "Ready for review",
  live: "Live",
  suspended: "Suspended",
};

const WebsiteRequests = () => {
  const { socket } = useNotifications();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadRequests = useCallback(async () => {
    try {
      const response = await websiteApi.getClientRequests();
      setRequests(response.data || []);
      setError("");
    } catch (loadError) {
      setError(
        loadError.response?.data?.error ||
          "Could not load your website requests.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  useEffect(() => {
    if (!socket) return undefined;
    socket.on("website-request:updated", loadRequests);
    return () => socket.off("website-request:updated", loadRequests);
  }, [loadRequests, socket]);

  return (
    <main className="request-status-page">
      <header className="request-status-header">
        <div>
          <h2>Website requests</h2>
          <p>Review your project status, invoice, and payment updates.</p>
        </div>
        <Link className="request-status-primary-link" to="/website-onboarding">
          Start a website project
        </Link>
      </header>
      {error && <p role="alert">{error}</p>}
      {loading ? (
        <p role="status">Loading your website requests...</p>
      ) : requests.length ? (
        <div className="website-request-list">
          {requests.map((request) => {
            const status = String(request.Status || "pending").toLowerCase();
            return (
              <article
                className="website-request-list-card"
                key={request.WebsiteRequestID}
              >
                <div>
                  <h3>{request.BusinessName}</h3>
                  <p>
                    {request.PackageName} ·{" "}
                    {new Date(request.CreatedAt).toLocaleDateString()}
                  </p>
                  <span className={`request-badge request-badge--${status}`}>
                    <span className="request-badge-dot" />
                    {STATUS_LABELS[status] || status}
                  </span>
                </div>
                <div className="website-request-list-invoice">
                  <strong>{request.InvoiceNumber || "Invoice pending"}</strong>
                  <span>
                    Payment: {request.PaymentStatus || "not started"}
                  </span>
                </div>
                <Link to={`/website-request-status/${request.WebsiteRequestID}`}>
                  View project
                </Link>
              </article>
            );
          })}
        </div>
      ) : (
        <section className="request-status-card">
          <p>You have not submitted a website project yet.</p>
          <Link to="/website-onboarding">Start website onboarding</Link>
        </section>
      )}
    </main>
  );
};

export default WebsiteRequests;
